const BaseURL = process.env.REACT_APP_MERGEFLO_API_URL ?? '';
const idTag = '{id}';
const excelType = '{type}';
const Version = process.env.REACT_APP_MERGEFLO_API_VERSION ?? '';
const useRedis = process.env.USE_REDIS
  ? process.env.USE_REDIS === 'true'
  : false;
const ServicesConstants = {
  mergeflo: {
    dealspace: {
      create: BaseURL + Version + 'mergeflo/dealspace',
      retrieve: BaseURL + Version + 'mergeflo/dealspace/' + idTag,
      update: BaseURL + Version + 'mergeflo/dealspace/' + idTag,
      delete: BaseURL + Version + 'mergeflo/dealspace/' + idTag,
      downgrade:
        BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/downgrade',
      taskPrefixes:
        BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/taskPrefixes',
      tasks:
        BaseURL +
        Version +
        'mergeflo/dealspace/' +
        idTag +
        '/tasks' +
        (useRedis ? '' : 'Raw'),
      users: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/users',
      swimlaneOrder: `${BaseURL}${Version}mergeflo/dealspace/${idTag}/swimlaneOrder`,
      playbookSummary: `${BaseURL}${Version}mergeflo/dealspace/${idTag}/playbookSummary`,
      listPlaybooks: `${BaseURL}${Version}mergeflo/dealspace/${idTag}/playbooks`,
      bootTemplates: `${BaseURL}${Version}mergeflo/dealspace/${idTag}/bootTemplates `,
    },
    workspace: {
      list: BaseURL + Version + 'workspace/' + idTag + '/users',
    },
    dealspaceSubscribe: {
      create: `${BaseURL}${Version}mergeflo/dealspaceSubscribe/create`,
      basePackagePrice: `${BaseURL}${Version}mergeflo/dealspaceSubscribe/basePackagePrice`,
      aiUserCount: `${BaseURL}${Version}mergeflo/dealspaceSubscribe/userCount`,
      aiFeaturePrice: `${BaseURL}${Version}mergeflo/dealspaceSubscribe/aiPackagePrice`,
      getDealspaceSubscribe:
        `${BaseURL}${Version}mergeflo/dealspaceSubscribe/dealspace/` + idTag,
    },
    workspaceUser: {
      delete: BaseURL + Version + 'workspaceuser/' + idTag,
    },
    dealspaceUser: {
      create: BaseURL + Version + 'mergeflo/dealspaceuser',
      reminder:
        BaseURL + Version + 'mergeflo/dealspaceuser/' + idTag + '/reminder',
      retrieve: BaseURL + Version + 'mergeflo/dealspaceuser/' + idTag,
      removeDealspaceUser:
        BaseURL + Version + 'mergeflo/dealspaceuser/' + idTag,
      accept:
        BaseURL + Version + 'mergeflo/dealspaceuser/acceptInvite/' + idTag,
      reject:
        BaseURL + Version + 'mergeflo/dealspaceuser/rejectInvite/' + idTag,
    },
    dealspaceDirectory: {
      getDirectory:
        BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/directory',
    },
    functionalArea: {
      create: BaseURL + Version + 'mergeflo/functionalarea',
      list: BaseURL + Version + 'mergeflo/functionalarea',
      retrieve: BaseURL + Version + 'mergeflo/functionalarea/' + idTag,
      delete: BaseURL + Version + 'mergeflo/functionalarea/' + idTag,
      update: BaseURL + Version + 'mergeflo/functionalarea/' + idTag,
      listFunctionalAreasByDealspaceId:
        BaseURL +
        Version +
        'mergeflo/functionalarea/listByDealspaceId/' +
        idTag,
    },
    playbook: {
      create: BaseURL + Version + 'mergeflo/playbook',
      retrieve: BaseURL + Version + 'mergeflo/playbook/' + idTag,
      update: BaseURL + Version + 'mergeflo/playbook/' + idTag,
      delete: BaseURL + Version + 'mergeflo/playbook/' + idTag,
      addToSubscription:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/addToSubscription',
      removeFromSubscription:
        BaseURL +
        Version +
        'mergeflo/playbook/' +
        idTag +
        '/removeFromSubscription',
      importFromTemplates:
        BaseURL +
        Version +
        'mergeflo/playbook/' +
        idTag +
        '/importFromTemplates',
      importFromPersonalTemplates: `${BaseURL}${Version}mergeflo/playbook/${idTag}/importFromPersonalTemplates`,
      listTasks:
        BaseURL +
        Version +
        'mergeflo/playbook/' +
        idTag +
        '/tasks' +
        (useRedis ? '' : 'Raw'),
      listSections:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/sections',
      buildFromTemplate:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/buildFromTemplate',
      importTemplate:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/import',
      makeItTemplate:
        BaseURL +
        Version +
        'mergeflo/playbook/' +
        idTag +
        '/makeItTemplate/true',
      makeItPersonalTemplate: `${BaseURL}${Version}mergeflo/playbook/${idTag}/makeItPersonalTemplate`,
      personalTemplates: `${BaseURL}${Version}mergeflo/template/personal`,
      revertTemplate:
        BaseURL +
        Version +
        'mergeflo/playbook/' +
        idTag +
        '/makeItTemplate/false',
      templateStructure: `${BaseURL}${Version}user/templateStructure`,
      createNewTemplate: `${BaseURL}${Version}userTemplate`,
      importFromCSVPersonalTemplates: `${BaseURL}${Version}userTemplate/createWithCsv`,
    },
    task: {
      create: BaseURL + Version + 'mergeflo/task',
      retrieve: BaseURL + Version + 'mergeflo/task/' + idTag,
      update: BaseURL + Version + 'mergeflo/task/' + idTag,
      delete: BaseURL + Version + 'mergeflo/task/' + idTag,
      parent: BaseURL + Version + 'mergeflo/task/parent/' + idTag,
      createSubTask: BaseURL + Version + 'mergeflo/task/subtask',
      changeParentTask: BaseURL + Version + 'mergeflo/task/core/' + idTag,
    },
    issue: {
      create: BaseURL + Version + 'mergeflo/issue',
    },
    risk: {
      create: BaseURL + Version + 'mergeflo/risk',
    },
    decision: {
      create: BaseURL + Version + 'mergeflo/decision',
    },
    dependency: {
      create: BaseURL + Version + 'mergeflo/dependency',
      retrieve: BaseURL + Version + 'mergeflo/dependency/' + idTag,
      update: BaseURL + Version + 'mergeflo/dependency/' + idTag,
    },
    freetext: {
      list: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/freetext',
      create: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/freetext',
      playbookList:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/freetext',
      playbookCreate:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/freetext',
      delete: BaseURL + Version + 'mergeflo/freedata/' + idTag,
      update: BaseURL + Version + 'mergeflo/freedata/' + idTag,
    },
    dealBackground: {
      list: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/background',
      create: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/background',
      delete: BaseURL + Version + 'mergeflo/freedata/' + idTag,
      update: BaseURL + Version + 'mergeflo/freedata/' + idTag,
    },
    accomplishments: {
      list:
        BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/accomplishment',
      create:
        BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/accomplishment',
      playbookList:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/accomplishment',
      playbookCreate:
        BaseURL + Version + 'mergeflo/playbook/' + idTag + '/accomplishment',
      delete: BaseURL + Version + 'mergeflo/freedata/' + idTag,
      update: BaseURL + Version + 'mergeflo/freedata/' + idTag,
    },
    dashboardImo: {
      list: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/dashImoSet',
      post: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/dashImoSet',
    },
    dashboardWorkstream: {
      list:
        BaseURL +
        Version +
        'mergeflo/dealspace/' +
        idTag +
        '/dashWorkstreamSet',
      post:
        BaseURL +
        Version +
        'mergeflo/dealspace/' +
        idTag +
        '/dashWorkstreamSet',
    },
    dashboardExecutive: {
      list: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/dashExecSet',
      post: BaseURL + Version + 'mergeflo/dealspace/' + idTag + '/dashExecSet',
    },
    template: {
      getTemplates: BaseURL + Version + 'mergeflo/template/',
    },
    payment: {
      portalLink: BaseURL + Version + 'payment/portal-link',
      dealspaceSubscribeCancel:
        BaseURL + Version + 'mergeflo/dealspaceSubscribe/cancel',
    },
  },
  core: {
    user: {
      retrieve: BaseURL + Version + 'user',
      assets: BaseURL + Version + 'user/assets',
      dealspaces: BaseURL + Version + 'user/dealspaces',
      update: BaseURL + Version + 'user',
      playbookSettings: BaseURL + Version + 'user/playbookSettings',
    },
    auth: {
      login: BaseURL + Version + 'auth/login',
      refreshToken: BaseURL + Version + 'auth/refreshtoken',
      register: BaseURL + Version + 'auth/signup',
      registerConfirm: BaseURL + Version + 'auth/signup/confirm',
      forgotPassword: BaseURL + Version + 'auth/forgotpassword/',
      confirmForgotPassword: BaseURL + Version + 'auth/forgotpassword',
      resetPassword: BaseURL + Version + 'auth/changePassword',
    },
    workspace: {
      create: BaseURL + Version + 'workspace',
      retrieve: BaseURL + Version + 'workspace/' + idTag,
      update: BaseURL + Version + 'workspace/' + idTag,
      delete: BaseURL + Version + 'workspace/' + idTag,
    },
    workspaceUser: {
      create: BaseURL + Version + 'workspaceuser',
      retrieve: BaseURL + Version + 'workspaceuser/' + idTag,
      update: BaseURL + Version + 'workspaceuser/' + idTag,
      delete: BaseURL + Version + 'workspaceuser/' + idTag,
      accept: BaseURL + Version + 'workspaceuser/acceptInvite/' + idTag,
      reject: BaseURL + Version + 'workspaceuser/rejectInvite/' + idTag,
    },
    project: {
      create: BaseURL + Version + 'project',
      retrieve: BaseURL + Version + 'project/' + idTag,
      update: BaseURL + Version + 'project/' + idTag,
      delete: BaseURL + Version + 'project/' + idTag,
      listSections: BaseURL + Version + 'project/' + idTag + '/sections',
      listTasks: BaseURL + Version + 'project/' + idTag + '/tasks',
      listUsers: BaseURL + Version + 'project/' + idTag + '/users',
    },
    projectSection: {
      create: BaseURL + Version + 'projectsection',
      retrieve: BaseURL + Version + 'projectsection/' + idTag,
      update: BaseURL + Version + 'projectsection/' + idTag,
      delete: BaseURL + Version + 'projectsection/' + idTag,
      undoRemove:
        BaseURL + Version + 'projectsection/' + idTag + '/undoRemove ',
      updateSectionOrder:
        BaseURL + Version + 'projectsection/' + idTag + '/updateSectionOrder',
    },
    projectUser: {
      create: BaseURL + Version + 'projectuser',
      retrieve: BaseURL + Version + 'projectuser/' + idTag,
      update: BaseURL + Version + 'projectuser/' + idTag,
      delete: BaseURL + Version + 'projectuser/' + idTag,
      accept: BaseURL + Version + 'projectuser/acceptInvite/' + idTag,
      reject: BaseURL + Version + 'projectuser/rejectInvite/' + idTag,
      reminder: BaseURL + Version + 'projectuser/' + idTag + '/reminder',
    },
    task: {
      excel: BaseURL + Version + 'mergeflo/excel/' + idTag + '/' + excelType,
      create: BaseURL + Version + 'task',
      createSubTask: BaseURL + Version + 'task/subtask',
      retrieve: BaseURL + Version + 'task/' + idTag,
      update: BaseURL + Version + 'mergeflo/task/core/' + idTag,
      delete: BaseURL + Version + 'mergeflo/task/' + idTag,
      undoRemove: BaseURL + Version + 'mergeflo/task/' + idTag + '/undoRemove',
      listProjects: BaseURL + Version + 'task/' + idTag + '/projects',
      listComments: BaseURL + Version + 'mergeflo/task/' + idTag + '/comments',
      listAttachments:
        BaseURL + Version + 'mergeflo/task/' + idTag + '/attachments',
      convertToMilestone:
        BaseURL + Version + 'task/' + idTag + '/convertToMilestone',
      milestoneToTask: BaseURL + Version + 'task/' + idTag + '/milestoneToTask',
      listLogs: BaseURL + Version + 'mergeflo/task/' + idTag + '/logs',
      changeFamilyOrder:
        BaseURL + Version + 'task/' + idTag + '/changeFamilyOrder',
      changeSectionOrder:
        BaseURL + Version + 'task/' + idTag + '/changeSectionOrder',
    },
    taskProject: {
      create: BaseURL + Version + 'taskproject',
      retrieve: BaseURL + Version + 'taskproject/' + idTag,
      update: BaseURL + Version + 'taskproject/' + idTag,
      delete: BaseURL + Version + 'taskproject/' + idTag,
      updateSection: BaseURL + Version + 'taskproject',
      deleteTask: BaseURL + Version + 'taskproject',
      taskProject: BaseURL + Version + 'taskproject',
    },
    issue: {
      create: BaseURL + Version + 'issue',
      retrieve: BaseURL + Version + 'issue/' + idTag,
      update: BaseURL + Version + 'issue/' + idTag,
    },
    risk: {
      create: BaseURL + Version + 'risk',
      retrieve: BaseURL + Version + 'risk/' + idTag,
      update: BaseURL + Version + 'risk/' + idTag,
    },
    decision: {
      create: BaseURL + Version + 'decision',
      retrieve: BaseURL + Version + 'decision/' + idTag,
      update: BaseURL + Version + 'decision/' + idTag,
    },
    taskAttachment: {
      create: BaseURL + Version + 'mergeflo/task/attachment/' + idTag,
      retrieve: BaseURL + Version + 'taskattachment/fileContent/' + idTag,
      deleteAttachment: BaseURL + Version + 'taskattachment/' + idTag,
    },
    taskComment: {
      create: BaseURL + Version + 'mergeflo/task/comment',
      retrieve: BaseURL + Version + 'taskcomment/' + idTag,
      update: BaseURL + Version + 'taskcomment/' + idTag,
      delete: BaseURL + Version + 'taskcomment/' + idTag,
    },
    notification: {
      setup: BaseURL + Version + 'notification/setup',
      retrieve: BaseURL + Version + 'notification/list',
      read: BaseURL + Version + 'notification/' + idTag + '/read',
      unread: BaseURL + Version + 'notification/' + idTag + '/unread',
      allRead: BaseURL + Version + 'notification/read',
      allUnread: BaseURL + Version + 'notification/unread',
      unReadCount: BaseURL + Version + 'notification/' + idTag + '/count',
    },
    aiConversation: {
      create: BaseURL + Version + 'aiconversation',
      uploadDocument:
        BaseURL + Version + 'aiconversation/' + idTag + '/document',
    },
    aiPrompt: {
      promptCategoryAll:
        BaseURL +
        Version +
        'aipromptcategory?pageSize=100&pageNumber=1&search=&order=createdAt&orderDesc=true',
      promptAll:
        BaseURL +
        Version +
        'aiprompt?pageSize=1000&pageNumber=1&search=&order=createdAt&orderDesc=true',
      history:
        BaseURL +
        Version +
        'aiconversation/list/' +
        idTag +
        '?pageSize=100&pageNumber=1&order=&orderDesc=desc&search=',
      getContent: BaseURL + Version + 'aiconversation/' + idTag + '/content',
    },
  },
};

const DatabaseConstants = {
  allSectionTableName: 'projectSections',
  allTaskTableName: 'projectTasks',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { DatabaseConstants, ServicesConstants, idTag, excelType };
